import { ActionsObservable } from 'redux-observable'

export const forkEpic = (epicFactory: any, dependencies: any, state$: any, ...actions: any[]) => {
  const actions$ = ActionsObservable.of(...actions)
  return epicFactory(actions$, state$, dependencies)
}
